// src/config/pusher.js
import Pusher from 'pusher-js';

// Enable Pusher logging in development
Pusher.logToConsole = process.env.NODE_ENV === 'development';

// إنشاء اتصال Pusher واحد يمكن إعادة استخدامه
let pusherInstance = null;

export const getPusher = () => {
  if (!pusherInstance) {
    pusherInstance = new Pusher("1a6dafa4504c853b7f61", {
      cluster: "mt1",
      forceTLS: true,
      enabledTransports: ['ws', 'wss'],
    });
  }
  return pusherInstance;
};

export default getPusher;